import { Container } from 'reactstrap';
import { StudentRiskPrimaryFiltersLoaderData } from './hooks/StudentRiskFiltersLoader';
import {
  StudentsRiskHistoryLoaderConsumer,
  StudentsRiskHistoryLoaderProvider,
} from './hooks/StudentsRiskHistoryLoader';
import { useTexts } from './hooks/useTexts';
import { PrimaryFilters } from './PrimaryFilters';
import { SecondaryFilters } from './SecondaryFilters';
import { StudentsListTable } from './StudentsListTable';

export function StudentListContainer() {
  const { primaryFilters } = StudentRiskPrimaryFiltersLoaderData();
  const texts = useTexts();
  return (
    <StudentsRiskHistoryLoaderProvider
      fetchImmediately
      defaultQuery={{
        items_per_page: 10,
        page: 0,
        periodId: primaryFilters.defaultPeriod?.value,
        year: primaryFilters.defaultYear?.value,
        schoolId: primaryFilters.defaultSchool?.value,
      }}
    >
      <Container fluid>
        <div className="fs-16">{texts.subtitle}</div>
        <PrimaryFilters />
        <SecondaryFilters />
      </Container>
      <div className="w-100 mt-2 d-flex flex-wrap justify-content-center">
        <StudentsRiskHistoryLoaderConsumer>
          <Container fluid>
            <StudentsListTable />
          </Container>
        </StudentsRiskHistoryLoaderConsumer>
      </div>
    </StudentsRiskHistoryLoaderProvider>
  );
}
